<template>
    <v-ons-page>
        <v-ons-toolbar>
            <div class="left">
                <v-ons-back-button>戻る</v-ons-back-button>
            </div>
            <div class="center">設定</div>
        </v-ons-toolbar>

        <div class="content">
            <v-ons-list>
                <v-ons-list-header>情報</v-ons-list-header>
                <v-ons-list-item tappable>
                    <span class="list-item__title">バージョン</span><span class="list-item__subtitle">0.0.3</span>
                </v-ons-list-item>

                <v-ons-list-item tappable
                    v-on:click="pushAboutAppPage">
                    <span>このアプリについて</span>
                </v-ons-list-item>

                <!--<v-ons-list-item tappable>-->
                    <!--<v-ons-row>-->
                        <!--<v-ons-col>-->
                            <!--<span>著作権情報</span>-->
                        <!--</v-ons-col>-->
                        <!--<v-ons-col>-->
                            <!--<span></span>-->
                        <!--</v-ons-col>-->
                    <!--</v-ons-row>-->
                <!--</v-ons-list-item>-->
            </v-ons-list>
        </div>

    </v-ons-page>
</template>

<script>
import aboutApp from './AboutApp'

export default {
    name: "SettingHome",
    created() {
        this.$ga.page('/SettingHome')
    },
    methods: {
        pushAboutAppPage() {
            this.$emit('push-page', aboutApp)
        }
    }
}
</script>

<style scoped>

</style>
